import { holdsActiveCustomModel } from '../../../../../functions/client-model/client-node/holds-active-custom-model';
import { ClientNode } from '../../../../../model/client-model/client-node';
import { ClientBoardContainer } from '../../../../../public/dashboard/shared/model/client-board-container';

export function getCustomModelTargetsWithLhsCccs(board: ClientBoardContainer): ClientNode[] {
  const nodes = Object.values(board.nodes);
  return nodes.filter(holdsActiveCustomModel).filter((n) => n.nodeProperties?.customTargetModelData?.lhsCccs?.length);
}
